export default "__VITE_ASSET__Cy$qQbSe__"